import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Table from "../../components/admin/Table";
import { RoleService } from "../../services/RoleService";

export default function Roles() {
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();
  const service = new RoleService();

  useEffect(() => {
    fetchRoles();
  }, []);

  const fetchRoles = async () => {
    try {
      setLoading(true);
      const response = await service.find();

      // Format roles for display
      const formattedRoles = response.items.map((role) => ({
        ...role,
        displayName: role.namePt || role.name,
        displayDescription: role.descriptionPt || role.description,
        permissionCount: role.permissions ? role.permissions.length : 0,
        typeLabel: getTypeLabel(role.type),
        canDelete: role.type === "CUSTOM",
      }));

      setRoles(formattedRoles);
    } catch (error) {
      console.error("Error fetching roles:", error);
      alert("Erro ao carregar grupos");
    } finally {
      setLoading(false);
    }
  };

  const getTypeLabel = (type) => {
    const types = {
      ADMIN: "Administrador",
      AUTHENTICATED: "Autenticado",
      CUSTOM: "Personalizado",
    };
    return types[type] || type;
  };

  const getRoleName = (role) => {
    return role.namePt || role.name;
  };

  const handleEdit = (role) => {
    navigate(`/admin/roles/${role._id}`);
  };

  const columns = [
    { label: "Nome", field: "displayName" },
    { label: "Descrição", field: "displayDescription" },
    { label: "Tipo", field: "typeLabel" },
    {
      label: "Permissões",
      field: "permissionCount",
      render: (row) => (
        <span className="badge bg-secondary">{row.permissionCount} permissões</span>
      ),
    },
    {
      label: "Status",
      field: "active",
      render: (row) => (
        <span className={`badge ${row.active ? "bg-success" : "bg-danger"}`}>
          {row.active ? "Ativo" : "Inativo"}
        </span>
      ),
    },
  ];

  if (loading) {
    return <div className="text-center mt-5">Carregando grupos...</div>;
  }

  return (
    <div className="container pt-5">
      <h2>Gerenciamento de Grupos e Permissões</h2>

      <Table
        columns={columns}
        data={roles}
        onEdit={handleEdit}
      />
    </div>
  );
}